export const cities = [
	{ name: 'San Francisco', location: 'San Francisco, CA' },
	{ name: 'Boston', location: 'Boston, MA' },
	{ name: 'Los Angeles', location: 'Los Angeles, CA' },
	{ name: 'NYC', location: 'New York, NY' },
	{ name: 'Seattle', location: 'Seattle, WA' }
];
